import React from 'react';
import {StandardMargin} from '../../../components/insights/invoicing/InvoicingPage.styled';
import {SubNavigation} from '@/web-components';
import {useIntl} from 'react-intl';
import {useHistory, useLocation} from 'react-router-dom';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../shared/components/headers/top-header-bar/TopHeaderBar';
import {findProjectSubPage, getProjectSubPages} from './projectSubPages';

const SettingsProjectSubNav = () => {
	const {formatMessage} = useIntl();
	const {pathname} = useLocation();
	const history = useHistory();
	const activeProjectSubPage = findProjectSubPage(pathname);

	const handleSetActivePage = value => {
		const newPage = getProjectSubPages().some(option => option.value === value);
		if (activeProjectSubPage?.value !== value && newPage) {
			history.push(value);
		}
	};

	return (
		<>
			<TopHeaderBarWrapper>
				<TopHeaderBar title={formatMessage({id: 'common.projects'})} />
			</TopHeaderBarWrapper>
			<div style={{marginTop: '20px'}}>
				<StandardMargin data-cy={'Projects-tabs'}>
					{getProjectSubPages().map(option => (
						<SubNavigation.NavigationItem
							active={activeProjectSubPage?.value === option.value}
							onClick={() => handleSetActivePage(option.value)}
							key={option.value}
							cy={option.testId}
							userpilot={option.testId}
						>
							{formatMessage({id: option.label})}
						</SubNavigation.NavigationItem>
					))}
				</StandardMargin>
			</div>
		</>
	);
};

export default SettingsProjectSubNav;
